export default __webpack_public_path__ + "static/Instructions-992195e37d68fa27c3f44db7bf9b369c.png";